import Image from "core/assets/images/index.js";

const data = [
  {
    image: Image.blog_2,
    title:
      "Simplify Reimbursement by Connecting Your Business Profile to Concur Expense",
    by: "Gocorp",
    date: "21 Mar 2024",
    link : "https://www.gojek.com/blog/gocorp/business-profile-int-sap-concur"
  },
  {
    image: Image.blog_1,
    title: "Mempermudah Distribusi Fasilitas Transportasi & Makanan",
    by: "Gocorp",
    date: "21 Mar 2024",
    link : "https://www.gojek.com/blog/gocorp/voucher-code-feature"
  },
  {
    image: Image.blog_3,
    title:
      "Urusan administrasi semakin mudah dengan fitur Multiakun Perusahaan",
    by: "Gocorp",
    date: "21 Mar 2024",
    link : "https://www.gojek.com/blog/gocorp/multi-account-feature"
  },
  {
    image: Image.blog_4,
    title:
      "Promo GoFood: Pesan Makan & Minuman Hemat, Bayarnya Pakai Kartu Bank BCA",
    by: "Gofood",
    date: "12 Mar 2024",
    link : "https://www.gojek.com/blog/gofood/promo-gofood-bankbca"
  },
  {
    image: Image.blog_5,
    title:
      "Pesan GoRide, GoCar & GoFood Makin Hemat, Bayarnya Pakai Kartu Kredit Mayapada",
    by: "Gofood",
    date: "12 Mar 2024",
    link : "https://www.gojek.com/blog/gofood/promo-gojek-bankmayapada"
  },
  {
    image: Image.blog_6,
    title: "Promo MAKSIMAL Ramadan dari GoFood",
    by: "Gofood",
    date: "15 Mar 2024",
    link : "https://www.gojek.com/blog/gofood/promo-ramadan"
  },
  {
    image: Image.blog_7,
    title:
      "Makin mudah pesan makanan untuk keperluan bisnis lewat website GoFood",
    by: "Gocorp",
    date: "21 Mar 2024",
    link : "https://www.gojek.com/blog/gocorp/gofood-website-order"
  },
  {
    image: Image.blog_9,
    title:
      "Lipat Gandakan Pahala Puasa dengan Berkontribusi di Kampoeng Ramadan Jogokaryan ",
    by: "Gofood",
    date: "27 Mar 2024",
    link : "https://www.gojek.com/blog/gojek/gojek-jogokaryan"
  },
  {
    image: Image.blog_8,
    title: "Mempermudah Distribusi Fasilitas Transportasi & Makanan",
    by: "Gojek",
    date: "21 Mar 2024",
    link : "https://www.gojek.com/blog/gofood/promo-gojek-visa"
  },
];

export default data;
